import { friendlySdgName } from '@upright/common/model/input/sdg-alignment/friendly';
import { SdgAlignmentsLayout, SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import InfoTooltipWithIcon from '@upright/ui/common/generic/components/tooltips/info-tooltip-with-icon';
import { TabletOrWiderOnly } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';
import { SdgRowProps } from '.';
import { useSdgAlignmentsContext } from '../context';
import { getSdgIconSize, getSdgRowHeight, sdgIconAndNameWidth } from '../shared';
import { getSdgIcon } from './sdg-icons/get-sdg-icon';

export const SdgIconAndName = (props: SdgRowProps) => {
  const { layout, disableInteraction } = useSdgAlignmentsContext().viewOptions;

  const icon = getSdgIcon(props.sdgId);
  const name = friendlySdgName(props.sdgId);

  const shouldShowTooltip = props.sdgId === SdgId._8_Decent_Work_and_Economic_Growth && !disableInteraction;

  return (
    <Root layout={layout}>
      <IconWrap layout={layout}>{icon}</IconWrap>
      <TabletOrWiderOnly>
        <NameWrap>
          {name}
          {shouldShowTooltip ? (
            <InfoTooltipWithIcon
              content={
                <div style={{ maxWidth: '30em' }}>
                  <>{sdg8TooltipText}</>
                </div>
              }
              darkStyle={false}
              style={{ marginLeft: '0.5em' }}
            />
          ) : undefined}
        </NameWrap>
      </TabletOrWiderOnly>
    </Root>
  );
};

const sdg8TooltipText = `All companies that generate revenue align to some degree with SDG 8, which focuses on economic growth measured by GDP growth. All products generating revenue contribute, to a degree, to this economic growth.`;

const Root = styled.div<{ layout?: SdgAlignmentsLayout }>`
  ${sdgIconAndNameWidth}
  height: ${props => getSdgRowHeight(props.layout)};
  display: flex;
  align-items: center;
  > * + * {
    margin-left: 2em;
  }
`;

const IconWrap = styled.div<{ layout?: SdgAlignmentsLayout }>`
  ${props => {
    const size = getSdgIconSize(props.layout);
    return css`
      width: ${size};
      height: ${size};
      svg {
        width: ${size};
        height: ${size};
      }
    `.join('');
  }}
`;

const NameWrap = styled.div`
  display: flex;
`;
